import { initializeApollo } from "@lib/apollo";

export const getPages = async ({ getPageProps }) => {
  const apolloClient = initializeApollo();
  const { data } = await apolloClient.query(getPageProps);
  return data;
};
